const COLUMN_LINKS = [
  { label: "风向热搜榜", href: "#trending" },
  { label: "五大反应分类", href: "#reactions" },
  { label: "深度洞察", href: "#analysis" },
  { label: "舆情时间线", href: "#timeline" },
  { label: "粉圈黑话词典", href: "#glossary" },
  { label: "常见问题", href: "#faq" },
  { label: "关于本站", href: "#about" },
];

const QUICK_TERMS = ["塌房", "脱粉", "回踩", "站姐", "超话", "后援会", "路人缘", "关站"];

export default function Footer() {
  return (
    <footer className="bg-background-900 text-background-100">
      <div className="mx-auto max-w-[1280px] px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-12">
          {/* brand */}
          <div className="md:col-span-5">
            <a href="#top" className="flex items-center gap-2.5">
              <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-500 text-background-50">
                <i className="ri-radar-line text-lg" aria-hidden="true"></i>
              </span>
              <span>
                <span className="block font-heading text-xl font-bold text-background-50">星闻雷达</span>
                <span className="mt-0.5 block text-[11px] tracking-[0.3em] text-background-100/70">
                  塌房舆论观察
                </span>
              </span>
            </a>
            <p className="mt-5 max-w-sm text-sm leading-relaxed text-background-100/80">
              聚焦明星塌房事件后的粉圈风向：脱粉、回踩、后援会波动、超话失守与站姐动向。
              以匿名化、多信源的冷静视角，记录粉丝立场转变与舆论体温。
            </p>
            <div className="mt-6 flex flex-wrap gap-2">
              {QUICK_TERMS.map((t) => (
                <a
                  key={t}
                  href="#glossary"
                  className="whitespace-nowrap rounded-full bg-background-800 px-3 py-1 text-xs text-background-100/80 transition-colors hover:bg-background-700 hover:text-background-50"
                >
                  # {t}
                </a>
              ))}
            </div>
          </div>

          {/* site links */}
          <div className="md:col-span-4">
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">站内栏目</h3>
            <ul className="mt-4 grid grid-cols-2 gap-x-4 gap-y-3">
              {COLUMN_LINKS.map((l) => (
                <li key={l.href}>
                  <a
                    href={l.href}
                    className="text-sm text-background-100/75 transition-colors hover:text-background-50"
                  >
                    {l.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          {/* contact / note */}
          <div className="md:col-span-3">
            <h3 className="font-heading text-sm font-bold tracking-wide text-background-50">联系我们</h3>
            <p className="mt-4 text-sm leading-relaxed text-background-100/75">
              投稿、线索与栏目建议：
            </p>
            <a
              href="mailto:hello@xingwenradar.cn"
              className="mt-2 inline-flex items-center gap-2 font-heading text-base font-semibold text-background-50 transition-opacity hover:opacity-80"
            >
              <i className="ri-mail-line" aria-hidden="true"></i>
              hello@xingwenradar.cn
            </a>
            <p className="mt-5 text-xs leading-relaxed text-background-100/55">
              本站以现象观察与粉丝行为分析为目的，涉及事实的内容以官方与权威信源为准，不构成对任何个人的定性。
            </p>
          </div>
        </div>
      </div>

      <div className="border-t border-background-800">
        <div className="mx-auto flex max-w-[1280px] flex-col items-center justify-between gap-3 px-4 py-5 text-xs text-background-100/60 sm:flex-row md:px-6">
          <p>© 2026 星闻雷达 · 保留所有权利</p>
          <a href="#top" className="inline-flex items-center gap-1 transition-colors hover:text-background-50">
            回到顶部
            <i className="ri-arrow-up-line" aria-hidden="true"></i>
          </a>
        </div>
      </div>
    </footer>
  );
}